import Ajax from '@/lib/ajax'

export default {
  // 获取分页
  getPageList(MaxResultCount: number, currentPage: number, KeyWord?: string, Published?: any) {
    let params = {
      MaxResultCount,
      SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * MaxResultCount,
    }
    if(KeyWord) {
      params['KeyWord'] = KeyWord
    }
    if(Published != null) {
      params['Published'] = Published
    }
    return Ajax.get(`/api/MarketingManagement/RechargeableCard/Paged`, {
      params
    })
  },
  // 根据id获取单行
  getDetail(id: string) {
    return Ajax.get(`/api/MarketingManagement/RechargeableCard/${id}`)
  },
  // 根据id修改
  updateDetail(id: string, data: any) {
    return Ajax.put(`/api/MarketingManagement/RechargeableCard/${id}`, data)
  },
  // 创建卡密
  createChargeCard(data: any) {
    return Ajax.post(`/api/MarketingManagement/RechargeableCard`, data)
  },
  // 批量删除卡密子表
  batchDelete(ids: any) {
    let text = ids.join('&ids=')
    return Ajax.delete(`/api/MarketingManagement/RechargeableCard?ids=${text}`)
  },

  // 创建卡密商品
  createChargeProductCard(data: any) {
    return Ajax.post(`/api/MarketingManagement/RechargeableProductCard`, data)
  },
  // 根据id修改卡密商品
  updateProductDetail(id: string, data: any) {
    return Ajax.put(`/api/MarketingManagement/RechargeableProductCard/${id}`, data)
  },
  // 根据id获取单行卡密商品
  getProductDetail(id: string) {
    return Ajax.get(`/api/MarketingManagement/RechargeableProductCard/${id}`)
  },
  // 批量删除卡密子表
  batchDeleteProdcut(ids: any) {
    let text = ids.join('&ids=')
    return Ajax.delete(`/api/MarketingManagement/RechargeableProductCard/Items?ids=${text}`)
  },
  // 自动生成随机卡密
  autoGenerate(number: number) {
    return Ajax.get(`/api/MarketingManagement/RechargeableProductCard/Generate/${number}`)
  },
  // 导出卡密商品里面的卡密
  exportRechargeableProduct(id: string) {
    let params = {
      id
    }
    return Ajax.get(`/api/MarketingManagement/userCoupon/ExportItems`, {
      params,
      responseType: 'blob'
    })
  },
  // 导出卡密里面的卡密
  exportRechargeable(id: string) {
    return Ajax.get(`/api/MarketingManagement/RechargeableCard/export/${id}`, {
      responseType: 'blob'
    })
  },
}